import AnnouncementItem from '@/components/sections/builder/elements/header/announcement/announcement-item';
import ElementContent from '@/components/sections/builder/elements/header/announcement/content';
import ElementSetting from '@/components/sections/builder/elements/header/announcement/setting';
import { AnnouncementElementDataType } from '@/components/sections/builder/elements/header/announcement/types';
import { BetweenHorizonalStart } from 'lucide-react';

const defaultData: AnnouncementElementDataType = {
  name: 'Announcement',
  contentAlign: 'center',
  socialIconAlign: 'left',
  changeEvery: 3,
  padding: {
    bottom: 14,
    top: 14,
    right: 0,
    left: 0,
  },
};

export const ElementPreviewIcon = BetweenHorizonalStart;

const Announcement = {
  type: 'announcement',
  group: 'header',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [AnnouncementItem],
  childs: [AnnouncementItem],
};

export default Announcement;
